import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Loads Stripe.js on first use. The `/pure` entry point is what makes this
 * lazy: the default `@stripe/stripe-js` entry injects the script tag as an
 * import side effect, which put a third-party request on every page that
 * shared a chunk with this module (including provider job pages that never
 * show a payment form).
 *
 * A failed load (ad blocker, offline, flaky network) resolves to null instead
 * of rejecting, so it cannot become an unhandled rejection, and the cache is
 * cleared so the next payment form can try again.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(
      import.meta.env.VITE_PUBLIC_STRIPE_PUBLISHABLE_KEY,
    ).catch(() => {
      stripePromise = null;
      return null;
    });
  }
  return stripePromise;
}
